export const SET_AUTH = "SET_AUTH";
export const REMOVE_AUTH = "REMOVE_AUTH";

export const setAuth = (user) => ({ type: SET_AUTH, payload: user });
export const removeAuth = () => ({ type: REMOVE_AUTH });
